// @ts-nocheck
import { getToken } from './utils/api/helpers';
const API_URL = (process.env.REACT_APP_BASE_API_URL_SYNC || 'http://localhost:32768').trim();
const NOTIFICACOES_STREAM_URL = new URL('/api/v1/notificacoes/stream', API_URL).toString();
// Conecta ao stream SSE de notificações (SyncTransben)
// Retorna função para desconectar
export const connectNotificacoesStream = (onMessage) => {
    const token = getToken();
    const url = `${NOTIFICACOES_STREAM_URL}?token=${encodeURIComponent(token || '')}`;
    const es = new EventSource(url);
    es.onmessage = (e) => {
        try {
            const data = JSON.parse(e.data);
            if (onMessage)
                onMessage(data);
        }
        catch (_e) { }
    };
    es.onerror = () => {
        // EventSource faz auto-reconnect; sem ação
    };
    return () => es.close();
};
